import { Fight } from '../models/fight.model';
import { FightResult } from '../models/fightResult.enum';
import { RecentFightResult } from '../models/recentFightResult.model';

export const isCompletedFight = (fight: Fight, fighterId: string): boolean => {
  const hasParticipated =
    fight.fighter_1_id === fighterId || fight.fighter_2_id === fighterId;
  const hasResult =
    fight.winner !== '' || (fight.winner === '' && fight.result !== '');
  const isPastFight = new Date(fight.date) < new Date();

  return hasParticipated && hasResult && isPastFight;
};

export const determineFightResult = (
  fight: Fight,
  fighterId: string,
): FightResult => {
  const isFirstFighter = fight.fighter_1_id === fighterId;
  const opponent = isFirstFighter ? fight.fighter_2_id : fight.fighter_1_id;

  if (fight.winner_id === fighterId) {
    return FightResult.WIN;
  } else if (fight.winner_id === opponent) {
    return FightResult.LOSS;
  } else if (fight.winner_id === '' && fight.result === 'Decision') {
    return FightResult.DRAW;
  }
  return FightResult.NO_CONTEST;
};

export const createEmptyResults = (
  numberOfFights: number,
): RecentFightResult[] => {
  return Array(numberOfFights).fill({
    result: FightResult.NONE,
    isTitleFight: false,
  });
};

export const sortFightsByDate = (fights: Fight[]): Fight[] => {
  return [...fights].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime(),
  );
};

export const formatDateWithLeadingZeros = (
  dateInput: string | Date,
): string => {
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}.${month}.${year}`;
};
